import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import TimeOutputLayoutList from 'components/organismos/master/attend/TimeOutputLayout/TimeOutputLayoutList';

const TimeOutputLayoutListPage: React.FC = () => (
  <SidebarTemplate>
    <TimeOutputLayoutList />
  </SidebarTemplate>
);

export default TimeOutputLayoutListPage;
